import { DEFAULT_ADDRESS_RADIUS } from "@/constants/settings";

export const SET_MAIN_PAGE_SEARCH = "setMainPageSearch";

export default function mainPageSearch(
    state = {
        loading_address: null,
        loading_address_radius: DEFAULT_ADDRESS_RADIUS,
        unloading_address: null,
        unloading_address_radius: DEFAULT_ADDRESS_RADIUS,
    },
    action,
) {
    switch (action.type) {
        case SET_MAIN_PAGE_SEARCH:
            return { ...state, ...action.payload };
        default:
            return { ...state };
    }
}
